import * as React from 'react';

import androidTvSelected from '../../../assets/android-tv-ON.svg';
import androidTvUnselected from '../../../assets/android-tv-OFF.svg';
import androidTvDisabledSelected from '../../../assets/android-tv-DISABLED-ON.svg';
import androidTvDisabledUnselected from '../../../assets/android-tv-DISABLED-OFF.svg';

import { IconProps } from '../../typescriptHelpers';

interface AndroidTvIconProps extends IconProps {
    isSelected: boolean;
    isDisabledTreatment: boolean;
}

const AndroidTVIcon: React.FC<AndroidTvIconProps> = (props: AndroidTvIconProps) => {
    const selectedImage = androidTvSelected;
    const unselectedImage = androidTvUnselected;
    const disabledSelectedImage = androidTvDisabledSelected;
    const disabledUnselectedImage = androidTvDisabledUnselected;

    let sourceImage = props.isSelected ? selectedImage : unselectedImage;
    if (props.isDisabledTreatment) {
        sourceImage = props.isSelected ? disabledSelectedImage : disabledUnselectedImage;
    }

    return <img src={sourceImage} width={props.width} height={props.height} />;
};

export default AndroidTVIcon;
